// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1c0d4861","453":"7e939053","455":"b6863e61","977":"85997dd6"}[chunkId] + ".chunk.js";
};